import Head from 'next/head';
import React from 'react';
import MyProductsSection from '../../components/sections/my-product';
import ComingSoon from '../../components/widgets/coming-soon';
import DashboardLayout from '../../components/widgets/dashboard-layout';
import Protected from '../../hoc/protected-route';

const AIWriter = () => {
  return (
    <>
      <Head>
        <title>My Products</title>
        <meta
          name="description"
          content="A Simple Affiliate Cart System That Allows You: Take Affiliate Orders in Dollars & Major African Currencies By Simply Copying & Pasting a Single Line of Code on Your Website"
        />
        <link rel="icon" href="/favicon.png" />
      </Head>
      <ComingSoon />
    </>
  );
};

export default Protected(AIWriter);
